/* istanbul ignore file */
import BasicInformationForm from './BasicInformationForm';

export default BasicInformationForm;
